import { TRACKING_KEY, TRACKING_EVENT, TRACKING_VALUE } from 'shared/constants';

export const trackRiskProfilingOption = (tracking, riskType) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.RISK_PROFILE_OPTION,
    index: true,
    complex: false,
  };

  if (riskType === 'not_sure') {
    body.value = TRACKING_VALUE.FORMAL_RISK_PROFILE;
  } else {
    body.value = TRACKING_VALUE.PRE_RISK_PROFILE;
  }

  tracking.trackEvent(body);
};

export const trackRiskProfile = (tracking, riskProfile) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.RISK_PROFILE,
    value: riskProfile,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};
